import React from 'react'
import { About, Col, Row } from 'react-angle-dashboard-components'
import { useFacilityProfile } from './context'
import { AboutCol } from './style'

export const AboutSection = () => {
  const { current } = useFacilityProfile()

  return (
    <section className="pt-5 pb-2 container-fluid">
      <strong>About</strong>
      <Row className="my-3 px-2">
        <Col md="8">
          <Row>
            <AboutCol md={6}>
              <About smallText={'Specialty'} icon={'icon-specialty'}>
                <span className="text-capitalize">
                  {' '}
                  {current?.specialties
                    ? current?.specialties?.toLocaleLowerCase()
                    : 'Specialty Unavailable'}{' '}
                </span>
              </About>
            </AboutCol>
            <AboutCol md={6}>
              <About smallText={'County'} icon={'icon-location'}>
                <span className="text-capitalize">
                  {current?.county.toLocaleLowerCase()}
                </span>
              </About>
            </AboutCol>
          </Row>
        </Col>
      </Row>
    </section>
  )
}
